<button
  class="dropdown__options-button"
  [matMenuTriggerFor]="actionsDropdownMenu"
  #actionsMenuTrigger="matMenuTrigger"
  data-cy="action-dropdown"
>
  <rav-icon [name]="RavIconCircled.Ellipsis" class="dropdown__options-button-icon"></rav-icon>
  Options
</button>

<mat-menu #actionsDropdownMenu="matMenu">
  <div *ngFor="let action of actions" [ngClass]="!TableActions.shouldShow(action, selectedItems) ? 'hide' : ''">
    <button
      *ngIf="scope.hasAccesses(action.scope) && showAction(action)"
      (click)="actionTriggered.next(action.name)"
      [disabled]="!TableActions.isEnabled(action, selectedItems) || action.disabled"
      class="dropdown__button padding-horizontal-1"
    >
      <div class="grid-x align-middle">
        <div class="shrink cell">
          <rav-icon [name]="currentIcon(action)" class="dropdown__icon padding-right-1"></rav-icon>
        </div>
        <div class="shrink cell">{{ actionName(action) }}</div>
      </div>
    </button>
  </div>
</mat-menu>
